/**
 * @module TTProductTabsCustom
 * Entry point: registers the view on the theme placeholder (`data-view`).
 *
 * Mounting:
 * - Prefer **Layout.addChildView**: the placeholder resolves in the global DOM; in many setups
 *   **PDP.addChildView** does not wire `data-view` correctly inside PDP.
 * - Fallback: **PDP.addChildView** if the site expects registration only on the PDP component.
 * - `DATA_VIEW_PLACEHOLDER` must match the div `data-view` exactly (e.g. TavanoTeamProductDetailsInfo.Tabs).
 */
define('TTProductTabsCustom'
,	[
		'TTProductTabsCustom.View'
	]
,	function (
		TTProductTabsCustomView
	)
{
	'use strict';

	var DATA_VIEW_PLACEHOLDER = 'TavanoTeamProductDetailsInfo.Tabs';

	function mountView (container)
	{
		return new TTProductTabsCustomView({
			container: container
		});
	}

	return {
		mountToApp: function mountToApp (container)
		{
			var layout = container.getComponent('Layout');
			var pdp = container.getComponent('PDP');

			if (layout)
			{
				layout.addChildView(DATA_VIEW_PLACEHOLDER, function ()
				{
					return mountView(container);
				});
			}
			else if (pdp)
			{
				pdp.addChildView(DATA_VIEW_PLACEHOLDER, function ()
				{
					return mountView(container);
				});
			}
		}
	};
});
